import React from 'react';
import { Hero } from '../components/home/Hero';
import { Expertises } from '../components/home/Expertises';
import { Method } from '../components/home/Method';
import { References } from '../components/home/References';
import { Clients } from '../components/home/Clients';
import { News } from '../components/home/News';
import { ContactBand } from '../components/home/ContactBand';
export function Home() {
  return <>
      <Hero data-id="element-185" data-mp="1zjiew22247wp" />
      <Expertises data-id="element-186" data-mp="1zjs59qr0kh2x" />
      <Method data-id="element-187" data-mp="1zkabng7e4bok" />
      <References data-id="element-188" data-mp="24gsay0jybhti" />
      <Clients data-id="element-189" data-mp="24g8vcqhrx5in" />
      <News data-id="element-190" data-mp="24htnyakj2edv" />
      <ContactBand data-id="element-191" data-mp="24hk65a9mzdj9" />
    </>;
}